export const SELECT_PARCELS = 'SELECT_PARCELS'
export const DESELECT_PARCELS = 'DESELECT_PARCELS'
export const ADD_PROJECT = 'ADD_PROJECT'
export const MOVE_ITEM = 'MOVE_ITEM'
export const ADD_TO_PROJECT = 'ADD_TO_PROJECT'

export const selectParcels = parcels => ({
    type: SELECT_PARCELS,
    parcels: Array.isArray(parcels) ? parcels : [parcels]
})
export const deselectParcels = apn => ({ type: DESELECT_PARCELS, apns: Array.isArray(apn) ? apn : [apn] })
export const addProject = parcels => ({ type: ADD_PROJECT, parcels })
export const moveItem = (item, target, anchor) => ({ type: MOVE_ITEM, item, target, anchor })
export const addToProject = (parcel, project) => ({ type: ADD_TO_PROJECT, parcel, project })
